function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
//@ts-nocheck
import React from 'react';
//Customizable Area Start
import { Grid, Container, Typography, Card, CardContent, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, LinearProgress, Select, MenuItem, FormControl, TextField, Modal, Backdrop } from "@material-ui/core";
// import FileUploadIcon from '@mui/icons-material/FileUpload';
import { withStyles } from "@material-ui/styles";
import DashboardController from "./DashboardController";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title } from 'chart.js';
import { Doughnut, Line } from 'react-chartjs-2';
import { getformatedCurrentDate, noDataFound, pageLoader, skipped, down } from './utility';
import TimeCounter from './timeCounter';
import TargetSettingsForm from './TargetSettingsForm.web';
import OtpInput from "react-otp-input";
import CircularProgress from '@material-ui/core/CircularProgress';
ChartJS.register(ArcElement, Tooltip, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4
};
const modalFullStyle = {
  position: 'absolute',
  top: '10%',
  left: '20%',
  // transform: 'translate(-50%, -50%)',
  width: '60%',
  height: "80%",
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4
};
const backgroundImage = require("../assets/d556836cdbf3f98427e2ff9a6d3a66e43cc7b98f.png");
const exportIcon = require("../assets/exporticon.png");
const cleanDataIcon = require("../assets/cleaning.png");
const calibrateIcon = require("../assets/calibrate.png");
//Customizable Area End

export class DeviceInfo extends DashboardController {
  constructor(props) {
    super(props);
    //Customizable Area Start
    this.updateDeviceInformation("");
    this.getSelectedFlowData("");
    this.getCounterDetails('');
    this.getDeviceFilteredReports('default');
    this.getTargetSettings();
    //Customizable Area End
  }
  render() {
    var _this$state$targetDat, _this$state$targetDat2, _this$state$targetDat3, _this$state$targetDat4, _this$state$targetDat5, _this$state$targetDat6, _this$state, _this$state$deviceCou, _this$state$deviceCou2, _this$state$deviceCou3;
    const {
      navigation,
      classes
    } = this.props;

    //Customizable Area Start
    const lineOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
          display: false
        }
      }
    };
    const highestValue = this.state.chartFlowData.length > 2 ? this.state.chartFlowData.reduce((acc, val) => acc > val ? acc : val) : 0;
    const labels = this.state.chartLabels;
    const lineData = {
      labels,
      datasets: [{
        label: 'Dataset 1',
        data: this.state.chartFlowData,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 9, 132, 0.5)',
        segment: {
          borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
          borderDash: ctx => skipped(ctx, [6, 6])
        },
        spanGaps: true,
        tension: 0.3
      }, {
        label: 'Min Flow',
        fill: false,
        radius: 0,
        borderColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgba(0,0, 0, 0)',
        borderDash: [8, 5],
        data: this.state.minArray.fill(this.state.targetData.min_flow)
      }, {
        label: 'Max Flow',
        fill: false,
        radius: 0,
        borderColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgba(0,0, 0, 0)',
        borderDash: [8, 5],
        data: this.state.maxArray.fill(this.state.targetData.max_flow)
      }]
    };
    const rows = [{
      date: '11/10/2021',
      scale: 'Orange Weighing Scale #1',
      start_time: '00:00:17',
      end_time: '24:00:45',
      acc_weight: 6543.98,
      downtime: '-',
      empty_belt: '-',
      under_range: '-',
      opp_range: 19.45,
      over_range: 3.85,
      active_time: 23.10
    }];
    const subDevice = this.state.deviceMqttData;
    const deviceFlow = subDevice !== null && subDevice !== void 0 && subDevice.Flow && Math.sign(subDevice === null || subDevice === void 0 ? void 0 : subDevice.Flow) === 1 ? subDevice === null || subDevice === void 0 ? void 0 : subDevice.Flow : '0.00';
    const deviceSpeed = subDevice !== null && subDevice !== void 0 && subDevice.Speed && Math.sign(subDevice === null || subDevice === void 0 ? void 0 : subDevice.Speed) === 1 ? subDevice === null || subDevice === void 0 ? void 0 : subDevice.Speed : '0.00';
    const deviceLoad = subDevice !== null && subDevice !== void 0 && subDevice.Load && Math.sign(subDevice === null || subDevice === void 0 ? void 0 : subDevice.Load) === 1 && (subDevice === null || subDevice === void 0 ? void 0 : subDevice.Load) < 1000 ? subDevice === null || subDevice === void 0 ? void 0 : subDevice.Load : '0.00';
    const deviceTotal = subDevice === null || subDevice === void 0 ? void 0 : subDevice.Total;
    const disconnected = (subDevice === null || subDevice === void 0 ? void 0 : subDevice.stat) == 21 ? true : false;
    const clickLabel = {
      id: 'clickLabel',
      afterDraw: (chart, args, options) => {
        const {
          ctx,
          chartArea: {
            width,
            height,
            top
          }
        } = chart;
        ctx.save();
        ctx.font = 'bolder 40px Arial';
        ctx.fillStyle = "blue";
        ctx.textAlign = 'center';
        ctx.fillText("".concat(this.state.prdPercentage, "%"), width / 2, height / 2 + 20);
      }
    };
    const config = {
      type: 'doughnut',
      data: this.state.deviceData.chartData,
      options: {
        cutout: '78%',
        plugins: {
          legend: {
            display: false
          }
        },
        onClick: chart => {
          chart.draw();
        }
      },
      plugins: [clickLabel]
    };
    const flowPercentage = deviceFlow && (_this$state$targetDat = this.state.targetData) !== null && _this$state$targetDat !== void 0 && _this$state$targetDat.max_flow ? deviceFlow / ((_this$state$targetDat2 = this.state.targetData) === null || _this$state$targetDat2 === void 0 ? void 0 : _this$state$targetDat2.max_flow) * 100 : 0;
    const speedPercentage = deviceFlow && (_this$state$targetDat3 = this.state.targetData) !== null && _this$state$targetDat3 !== void 0 && _this$state$targetDat3.max_speed ? deviceSpeed / ((_this$state$targetDat4 = this.state.targetData) === null || _this$state$targetDat4 === void 0 ? void 0 : _this$state$targetDat4.max_speed) * 100 : 0;
    const loadPercentage = deviceFlow && (_this$state$targetDat5 = this.state.targetData) !== null && _this$state$targetDat5 !== void 0 && _this$state$targetDat5.max_load ? deviceLoad / ((_this$state$targetDat6 = this.state.targetData) === null || _this$state$targetDat6 === void 0 ? void 0 : _this$state$targetDat6.max_load) * 100 : 0;
    const totalPercentage = deviceTotal && this.state.prdPercentage ? this.state.prdPercentage <= 100 ? this.state.prdPercentage : 100 : 0;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.main
    }, this.state.showLoader ? /*#__PURE__*/React.createElement(Backdrop, {
      className: classes.backdrop,
      open: this.state.showLoader,
      onClick: this.handleBackDrop
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      color: "inherit"
    })) : "", /*#__PURE__*/React.createElement(Container, {
      maxWidth: "xl"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      className: classes.cardPrarent
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "h5",
      component: "div"
    }, "Production"), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.prodGraph
    }, /*#__PURE__*/React.createElement(Doughnut, _extends({
      id: "doughnutGraph"
    }, config))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        textAlign: "center"
      }
    }, disconnected ? /*#__PURE__*/React.createElement(Typography, {
      className: classes.disconnected
    }, "Disconnected") : deviceTotal ? /*#__PURE__*/React.createElement(Box, {
      className: classes.deviceLoadShow
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "Total"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadval,
      style: css.fontBold
    }, deviceTotal + ' t'), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "Production in Tons"), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      color: "primary",
      value: totalPercentage
    })) : ""))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 5,
      className: classes.cardPrarent
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.pZero
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.containerGrid
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 8
    }, /*#__PURE__*/React.createElement(Typography, {
      style: css.fontBold,
      gutterBottom: true,
      variant: "h5",
      component: "div"
    }, "Flow Rate in TPH")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true
    }, /*#__PURE__*/React.createElement(Select, {
      id: "deviceInfoMonth",
      value: this.state.selectedFlowOption,
      className: classes.deviceInfoMonthSelect,
      disableUnderline: true,
      onChange: this.handleSelectedFlowOption,
      inputProps: {
        classes: {
          icon: classes.selectIcon
        }
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: "1 hour"
    }, "1 hour"), /*#__PURE__*/React.createElement(MenuItem, {
      value: "6 hour"
    }, "6 hour"), /*#__PURE__*/React.createElement(MenuItem, {
      value: "12 hour"
    }, " 12 hour"), /*#__PURE__*/React.createElement(MenuItem, {
      value: "1 day"
    }, "1 day"), /*#__PURE__*/React.createElement(MenuItem, {
      value: "7 day"
    }, "7 day"), /*#__PURE__*/React.createElement(MenuItem, {
      value: "30 day"
    }, "30 day( Max )"))))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.containerGrid
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.prodGraph
    }, this.state.lineChartLoader ? pageLoader() : /*#__PURE__*/React.createElement(Line, {
      options: lineOptions,
      data: lineData
      // options={{ plugins: { legend: { display: false } } }} 
      // options={{ plugins: { tension } }} 
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      id: "fullScreenTPHModal",
      onClick: this.showFullModalForFlowRate,
      style: _objectSpread(_objectSpread({}, css.fontBold), {}, {
        color: '#79A1FA',
        textAlign: 'end',
        cursor: 'pointer'
      }),
      gutterBottom: true,
      component: "div"
    }, "See in Full screen")), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Modal, {
      id: "flowTPHGraphModal",
      open: ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.showFlowTPHGraph) || false,
      onClose: () => this.setState({
        showFlowTPHGraph: false,
        showLoaderModal: true
      }),
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      }
    }, /*#__PURE__*/React.createElement(Box, {
      sx: modalFullStyle
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.containerGrid
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 11
    }, /*#__PURE__*/React.createElement(Typography, {
      style: css.fontBold,
      gutterBottom: true,
      variant: "h5",
      component: "div"
    }, "Flow Rate in TPH")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 1,
      style: {
        textAlign: "end"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      id: "cancelFlowTPHGraph",
      variant: "contained",
      className: classes.btnUserCancel,
      onClick: () => this.setState({
        showFlowTPHGraph: false,
        showLoaderModal: true
      })
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#FFFFFF"
      }
    }, "x"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        margin: "auto"
      }
    }, this.state.showLoaderModal ? pageLoader() : /*#__PURE__*/React.createElement(Line, {
      options: lineOptions,
      data: this.state.chartFlowDataModal
    })))))), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.deviceLoadShow
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "Flow"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadval,
      style: css.fontBold
    }, deviceFlow), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "TPH"), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      color: "primary",
      value: flowPercentage <= 100 ? flowPercentage : 100
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.deviceLoadShow
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "Speed"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadval,
      style: css.fontBold
    }, deviceSpeed), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "M/S"), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      color: "primary",
      value: speedPercentage <= 100 ? speedPercentage : 100
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.deviceLoadShow
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "Load"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadval,
      style: css.fontBold
    }, deviceLoad), /*#__PURE__*/React.createElement(Typography, {
      className: classes.deviceLoadText,
      style: css.fontBold
    }, "KG/M"), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      color: "primary",
      value: loadPercentage <= 100 ? loadPercentage : 100
    }))))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4,
      className: classes.cardPrarent
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.logsDiv
    }, /*#__PURE__*/React.createElement(TimeCounter, {
      classes: classes,
      type: "start",
      timeString: (_this$state$deviceCou = this.state.deviceCounter) === null || _this$state$deviceCou === void 0 ? void 0 : _this$state$deviceCou.run_time
    })), /*#__PURE__*/React.createElement(Box, {
      className: classes.logsDiv + ' ' + classes.blueColor
    }, /*#__PURE__*/React.createElement(TimeCounter, {
      classes: classes,
      type: "down",
      timeString: (_this$state$deviceCou2 = this.state.deviceCounter) === null || _this$state$deviceCou2 === void 0 ? void 0 : _this$state$deviceCou2.down_time
    })), /*#__PURE__*/React.createElement(Box, {
      className: classes.logsDiv + ' ' + classes.darkGreyColor
    }, /*#__PURE__*/React.createElement(TimeCounter, {
      classes: classes,
      type: "idle",
      timeString: (_this$state$deviceCou3 = this.state.deviceCounter) === null || _this$state$deviceCou3 === void 0 ? void 0 : _this$state$deviceCou3.idle_time
    }))), /*#__PURE__*/React.createElement(Modal, {
      id: "clearModal",
      open: this.state.showClearModal,
      onClose: () => this.setState({
        showClearModal: false
      }),
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      }
    }, /*#__PURE__*/React.createElement(Box, {
      sx: modalStyle
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text3
    }, "OTP")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text4
    }, "Enter OTP we have sent you over your Email ID.")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(OtpInput, {
      value: this.state.otpObj.otp,
      onChange: this.handleOtpChange,
      numInputs: 6,
      inputStyle: classes.otpInput
    }), this.state.otpObj.otpErrorMessage && /*#__PURE__*/React.createElement("span", {
      className: classes.otpError
    }, this.state.otpObj.otpErrorMessage)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      fullWidth: true,
      disableElevation: true,
      className: classes.btnRoot,
      onClick: this.handleOtpSubmit
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.text5
    }, "Submit")))))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.cardPrarent
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React.createElement(Card, {
      onClick: () => this.clearData('clearData'),
      style: _objectSpread({
        marginBottom: "5%",
        cursor: 'pointer'
      }, css.postionRel),
      id: "clearData",
      className: classes.card2
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement("img", {
      style: css.postionAbs,
      src: cleanDataIcon,
      width: "50%"
    }), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "h5",
      component: "div"
    }, "Clear Data"))), /*#__PURE__*/React.createElement(Card, {
      onClick: () => this.clearData('calibrate'),
      id: "calibrateData",
      style: _objectSpread({
        cursor: 'pointer'
      }, css.postionRel),
      className: classes.card2
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement("img", {
      style: css.postionAbs,
      src: calibrateIcon,
      width: "50%"
    }), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "h5",
      component: "div"
    }, "Zero Calibrate")))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React.createElement(TargetSettingsForm, {
      navigation: undefined,
      id: ""
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.cardPrarent
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.prodGraph
    }, /*#__PURE__*/React.createElement("div", {
      role: "tabpanel",
      id: "simple-tabpanel-0",
      "aria-labelledby": "simple-tab-0"
    }, /*#__PURE__*/React.createElement(Box, {
      sx: {
        p: 0
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      style: {
        paddingBottom: 15,
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 8
    }, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "h6",
      component: "div"
    }, "Reports"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      className: classes.fieldContainer
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "startDateFilter",
      fullWidth: true,
      variant: "filled",
      label: "Start date",
      type: "date",
      name: "start_date",
      InputLabelProps: {
        shrink: true
      },
      InputProps: {
        classes: {
          root: classes.inputWhite
        },
        inputProps: {
          max: getformatedCurrentDate('')
        }
      },
      error: !this.state.filterObj.startDateValid,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "16px",
          color: 'red'
        }
      }, this.state.filterObj.startDateMsg),
      size: "small",
      value: this.state.filterObj.start_date,
      onChange: this.filterFieldChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      className: classes.fieldContainer
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "end_date",
      fullWidth: true,
      variant: "filled",
      label: " End date",
      type: "date",
      name: "end_date",
      InputLabelProps: {
        shrink: true
      },
      InputProps: {
        classes: {
          root: classes.inputWhite
        },
        inputProps: {
          max: getformatedCurrentDate('')
        }
      },
      error: !this.state.filterObj.endDateValid,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "16px",
          color: 'red'
        }
      }, this.state.filterObj.endDateMsg),
      value: this.state.filterObj.end_date,
      onChange: this.filterFieldChange,
      size: "small"
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        marginTop: "auto"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: this.validateDeviceFilterFields,
      size: "small",
      style: {
        marginRight: '5px'
      },
      id: "filterData"
    }, "Filter"), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: this.resetFilter,
      size: "small",
      id: "resetData"
    }, "Reset"))))), /*#__PURE__*/React.createElement(Grid, {
      style: {
        marginTop: 'auto'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: classes.exportBtn,
      color: "primary",
      variant: "contained",
      startIcon: /*#__PURE__*/React.createElement("img", {
        src: exportIcon
      }),
      onClick: this.exportPDFData,
      disabled: this.state.deviceReportsList.data.length > 0 ? false : true
    }, "Export PDF"), /*#__PURE__*/React.createElement(Button, {
      className: classes.exportBtn,
      color: "primary",
      variant: "contained",
      startIcon: /*#__PURE__*/React.createElement("img", {
        src: exportIcon
      }),
      onClick: this.exportCSVData,
      disabled: this.state.deviceReportsList.data.length > 0 ? false : true
    }, "Export CSV"))), this.state.deviceReportsList.loader ? pageLoader() : this.state.deviceReportsList.data.length > 0 ? /*#__PURE__*/React.createElement(TableContainer, {
      component: Paper
    }, /*#__PURE__*/React.createElement(Table, {
      "aria-label": "simple table"
    }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Date"), /*#__PURE__*/React.createElement(TableCell, null, "Start Time"), /*#__PURE__*/React.createElement(TableCell, null, "End Time"), /*#__PURE__*/React.createElement(TableCell, null, "Run Time (Hours)"), /*#__PURE__*/React.createElement(TableCell, null, "Idle Time (Hours)"), /*#__PURE__*/React.createElement(TableCell, null, "Down Time (Hours)"), /*#__PURE__*/React.createElement(TableCell, null, "Average Flow (TPH)"), /*#__PURE__*/React.createElement(TableCell, null, "Average Speed"), /*#__PURE__*/React.createElement(TableCell, null, "Average Load"), /*#__PURE__*/React.createElement(TableCell, null, "Production in Tons"))), /*#__PURE__*/React.createElement(TableBody, null, this.state.deviceReportsList.data.map((item, index) => /*#__PURE__*/React.createElement(TableRow, {
      key: "deviceDetailReports".concat(index)
    }, /*#__PURE__*/React.createElement(TableCell, {
      component: "th",
      scope: "row"
    }, item.date), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.start_time), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.end_time), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.run_time), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.idle_time), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.down_time), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.avg_flow), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.avg_speed), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.avg_load), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, item.weight)))))) : noDataFound(), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        paddingTop: '5px',
        textAlign: 'center'
      }
    }, this.state.deviceReportsList.loadMore ? /*#__PURE__*/React.createElement(Button, {
      className: classes.nextBtn,
      variant: "contained",
      disabled: true
    }, "Loading...") : this.state.deviceReportsList.page_count > 1 && this.state.deviceReportsList.current_page < this.state.deviceReportsList.page_count && /*#__PURE__*/React.createElement(Button, {
      id: "loadMoreButton",
      className: classes.nextBtn,
      variant: "contained",
      onClick: () => this.reportsNextPage('next')
    }, "Load More")))))))))))))));

    // Customizable Area End
  }
}

// Customizable Area Start
export const styles = theme => ({
  cardPrarent: {
    padding: '10px'
  },
  card: {
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    borderRadius: 20,
    padding: "20px",
    height: '100%'
  },
  card2: {
    ['& img']: {
      top: 0,
      right: 0
    },
    ['& div']: {
      marginTop: 'auto'
    },
    display: 'flex',
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    borderTopRightRadius: 250,
    overflow: 'unset',
    borderRadius: 40,
    marginRight: 20,
    height: '48%'
  },
  timeCounter: {
    padding: "20px"
  },
  logsDiv: {
    backgroundColor: 'green',
    color: 'white',
    padding: '20px',
    marginBottom: '20px',
    borderRadius: '15px'
  },
  blueColor: {
    backgroundColor: '#79A1FA'
  },
  darkGreyColor: {
    backgroundColor: 'darkgrey'
  },
  mediumText: {
    // color: 'grey',
    fontSize: '25px'
  },
  mediumText1: {
    fontWeight: 600
  },
  exportBtn: {
    margin: '0px 5px',
    padding: '10px 10px',
    backgroundColor: "#7AA2FA!important",
    borderRadius: 10,
    fontWeight: 600
  },
  pageBtnActive: {
    backgroundColor: "#7AA2FA!important",
    color: 'white',
    borderRadius: 15,
    fontWeight: 600,
    margin: '5px'
  },
  pageBtn: {
    borderRadius: 15,
    fontWeight: 600,
    margin: '5px'
  },
  nextBtn: {
    backgroundColor: 'black',
    color: 'white',
    borderRadius: 15,
    fontWeight: 600,
    margin: '5px'
  },
  font600: {
    fontWeight: 600
  },
  deviceLoadShow: {
    padding: '10px 20px'
  },
  deviceLoadText: {
    fontSize: "12px",
    color: "gray"
  },
  deviceLoadval: {
    fontSize: "20px"
  },
  deviceInfoMonthSelect: {
    backgroundColor: '#79A1FA',
    color: 'white',
    padding: "0px 15px",
    borderRadius: 5,
    marginBottom: "10px"
  },
  selectIcon: {
    color: 'white'
  },
  containerGrid: {
    padding: "5px 10px"
  },
  pZero: {
    padding: '0!important'
  },
  otpInput: {
    fontFamily: "Open sans",
    fontWeight: 600,
    fontSize: "24px",
    height: "auto",
    margin: "10px 5px",
    borderRadius: "8.8px",
    padding: "20px 10px 10px",
    border: "1px solid #CFCFCF",
    backgroundColor: "#F1F1F1",
    width: '45px!important'
  },
  btnRoot: {
    height: "50px",
    borderRadius: "15px !important",
    backgroundColor: "#79A1FA"
  },
  text3: {
    opacity: 1,
    backgroundColor: "transparent",
    fontWeight: 800,
    color: "#79A1FA",
    fontFamily: "AppleColorEmoji",
    fontSize: "40px"
  },
  text4: {
    color: "#B9BAC3",
    opacity: 1,
    backgroundColor: "transparent",
    fontWeight: 600,
    fontFamily: "Poppins",
    fontSize: "14px"
  },
  text5: {
    color: "#FFFFFF",
    opacity: 1,
    backgroundColor: "transparent",
    fontFamily: "Poppins",
    fontSize: "14px"
  },
  otpError: {
    color: "red !important",
    paddingTop: "10px"
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  fieldContainer: {
    paddingRight: "15px"
  },
  inputWhite: {
    backgroundColor: "white"
  },
  disconnected: {
    color: 'red',
    fontSize: '20px',
    marginBottom: "10px",
    fontWeight: 700
  },
  quantity: {
    color: '#79A1FA',
    fontSize: '40px',
    fontWeight: 700
  },
  btnUserCancel: {
    backgroundColor: "#79A1FA",
    minWidth: "0px",
    borderRadius: "20px"
  }
});
const css = {
  postionRel: {
    position: "relative"
  },
  postionAbs: {
    position: "absolute"
  },
  fontBold: {
    fontWeight: "bold"
  }
};
// Customizable Area End

export default withStyles(styles, {
  withTheme: true
})(DeviceInfo);